module.exports = "\n\n<div align=\"center\">\n\n\n\n  <h1>\n      Reporting\n    </h1>\n\n  <div>\n    <button mat-raised-button style=\"margin-bottom: 20px;\" (click)=\"onBack()\"> Go Back </button>\n    <button mat-raised-button style=\"margin-bottom: 20px;\" (click)=\"data(this.initative[0].gsx$id.$t)\"> Data </button>\n  </div>\n\n  <div *ngIf=\"allDataFetched\">\n    <iframe width=475 height=600 id=\"db\" [src]='cleanURL()'></iframe>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/reports-past/reports/reports.component.html
// module id = ./src/app/pages/reports-past/reports/reports.component.html
// module chunks = main